<template>
  <main class="pp-page--choose-seats">
    <h1 class="title title--desktop">{{ $t('message.choose_seats', { sectionAlias: performance.sectionAlias}) }}</h1>
    <div class="pp-layout-container">
      <div class="pp-preamble">
        <h1 class="title title--mobile">{{ $t('message.choose_seats', { sectionAlias: performance.sectionAlias }) }}</h1>
      </div>
      <div class="pp-main-content">
        <seats-legend />
        <panZoom
          @init="initPanzoom"
          :options="{ minZoom: 0.5, maxZoom: 4, fit: true }"
        >
          <div class="seat-picker__container" ref="imageContainer">
            <svg
              ref="imageViewport"
              :viewBox="'0 0 ' + performance.backgroundImageWidth + ' ' + performance.backgroundImageHeight"
          >
              <image ref="backgroundMap" :href="performance.backgroundImageSource" />
              <!-- Available seats array -->
              <seat-item
                @selectSeat="selectSeat($event)"
                v-for="(seat, index) in performance.availableSeatsList"
                :index="index"
                :key="`available-seats--${index}--${seat.inventoryId}`"
                :seatInfo="seat"
                :available="true"
                :selected="seat.selected"
              />
              <!-- Unavailable seats array -->
              <seat-item
                v-for="(seat, index) in performance.unavailableSeatsList"
                :index="index"
                :key="`unavailable-seats--${index}--${seat.inventoryId}`"
                :data-cord="seat.topLeftCoordinates"
                :seatInfo="seat"
                :available="false"
                :selected="false"
                tabindex="-1"
              />
            </svg>
          </div>
        </panZoom>
        <zoom-controls @zoom="zoom" @resetPosition="resetPosition" />
        <pan-controls @pan="pan" />
        <fancy-button class="choose-seats__cta choose-seats__cta--desktop"
          @click.native="reserveTicketsCheck"
          :disabled="seatsSelected.length == 0"
          :text="$t('buttons.choose_seats')"
          :icon="['far', 'ticket-alt']"/>
        <div class="pp-actions">
          <div class="pp-actions__container">
            <seating-selection-info v-if="seatsSelected.length > 0"
              :seatSelectionDetails="seatSelectionDetails" />
            <fancy-button class="choose-seats__cta choose-seats__cta--mobile"
              @click.native="reserveTickets"
              :disabled="seatsSelected.length == 0"
              :text="$t('buttons.choose_seats')"
              :icon="['far', 'ticket-alt']"/>
          </div>
        </div>
      </div>
      <aside class="pp-sidebar">
        <seats-legend />
        <zoom-controls @zoom="zoom" @resetPosition="resetPosition" />
        <pan-controls @pan="pan" />
        <seating-selection-info v-if="seatsSelected.length > 0"
          :seatSelectionDetails="seatSelectionDetails" />
      </aside>
    </div>
  </main>
</template>

<script>
import _ from "lodash";
import SeatItem from "@/components/SeatItem";
import ZoomControls from "@/components/seating-area/ZoomControls";
import PanControls from "@/components/seating-area/PanControls";
import CanvasInteractions from "@/util/CanvasInteractions";
import FancyButton from "@/components/generic/FancyButton";
import SeatsLegend from "@/components/seating-area/SeatsLegend";
import SeatingSelectionInfo from "@/components/seating-area/SeatingSelectionInfo"
import { mapActions, mapState } from "vuex";

export default {
  name: "choose-seats",
  mixins: [CanvasInteractions],
  components: {
    SeatItem,
    ZoomControls,
    PanControls,
    FancyButton,
    SeatsLegend,
    SeatingSelectionInfo
  },
  data() {
    return {
      seatsSelected: [],
      seatSelectionDetails: {}
    };
  },
  watch: {
    "$i18n.locale": function() {
      this.initCreated();
    }
  },
  async created() {
    await this.initCreated();
  },
  methods: {
    async initCreated() {
      this.clearBackgroundImage();
      
      await this.retrieveSeatOptions().then(() => {
        this.updateLoading(false);
      });
    },
    selectSeat(seat) {
      let selected = _.get(
        this.performance.availableSeatsList[seat.index],
        "selected",
        false
      );

      if (selected) {
        this.toggleSeatSelection({ seatIndex: seat.index, value: false })
      } else {
        this.toggleSeatSelection({ seatIndex: seat.index, value: true })
      }

      // Managing the array of seatsSelected (by inventoryId)
      let inventoryId = this.performance.availableSeatsList[seat.index].inventoryId;
      let seatSelectedIndex = this.seatsSelected.indexOf(inventoryId);

      // This checks to see if the ID *doesn't* exist yet
      if (seatSelectedIndex == -1) {
        this.seatsSelected.push(inventoryId);
        this.$set(this.seatSelectionDetails, inventoryId, {
          row: seat.seatInfo.seatRowAlias,
          seat: seat.seatInfo.seatAlias
        });
      } else {
        this.seatsSelected.splice(seatSelectedIndex, 1);
        this.$delete(this.seatSelectionDetails, inventoryId);
      }

      this.updateInventoryReservedList(this.seatsSelected);
    },
    async reserveTicketsCheck() {
      if (this.seatsSelected.length === 0) {
        // do nothing
      } else {
        this.scrollToTopOfPurchasePath();

        await this.reserveTickets();

        this.$emit("chooseSeats");
      }
    },
    ...mapActions([
      'updateLoading',
      'updateInventoryReservedList',
      'retrieveSeatOptions',
      'toggleSeatSelection',
      'reserveTickets',
      'clearBackgroundImage',
      'scrollToTopOfPurchasePath'
    ])
  },
  computed: {
    seatSelectionInfo() {

    },
    ...mapState(['cart', 'performance'])
  },
};
</script>
